/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export { NzTypographyModule } from './typography.module';
export { NzTypographyComponent } from './typography.component';
export { NzTextCopyComponent } from './text-copy.component';
export { NzTextEditComponent } from './text-edit.component';
